import React from 'react';

/**
 * PWAGuard Component - SIMPLIFIED
 * 
 * This component has been simplified to remove forced PWA installation logic.
 * The new onboarding flow is handled by OnboardingModals component instead.
 * 
 * This component now simply passes through the children without any blocking.
 */
const PWAGuard = ({ children }) => {
  // Simply render children without any blocking
  // Onboarding is now handled by OnboardingModals component
  return children;
};

export default PWAGuard;